import React from 'react';
import {FieldErrors, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import FormGroupWithError from 'shared/ui/FormGroup/FormGroupWithError';
import TextAreaUrl from 'shared/ui/TextArea/TextAreaUrl';
import CreateHttpMonitorType from 'features/http/model/HttpMonitor/CreateHttpMonitorType';

import styles from './TextAreaBlock.module.scss';

interface ITextAreaBlockProps {
    errors: FieldErrors<CreateHttpMonitorType>;
    register: UseFormRegister<CreateHttpMonitorType>;
}

const TextAreaBlock: React.FC<ITextAreaBlockProps> = ({errors, register}) => {
    return (
        <FormGroupWithError
            error={errors?.url?.message}
            className={styles.wrapper}
        >
            <TextAreaUrl
                rows={5}
                register={register}
                placeholder={t`Вводите каждый URL с новой строки`}
                name="url"
            />
        </FormGroupWithError>
    );
};

export default TextAreaBlock;